import React from 'react';

import PropTypes from 'prop-types';

import { HeaderSubtitle } from '@src/components/ui';

const ProductAvailabilitySubtitle = ({ productSubtitle, text }) => (
    <>
        <div className="text-center">
            <h2>{ productSubtitle }</h2>
        </div>
        <HeaderSubtitle>{ text }</HeaderSubtitle>
    </>
);

ProductAvailabilitySubtitle.propTypes = {
    productSubtitle: PropTypes.node,
    text: PropTypes.node,
};

export default ProductAvailabilitySubtitle;
